export default "__VITE_PUBLIC_ASSET__77fb3856__"